// @flow

import _ from 'lodash/fp';
import React from 'react';
import './SearchField.css';

type Props = {
  placeholder?: string,
  value: ?string,
  onChange: (e: SyntheticInputEvent<*>) => void,
  onClear?: () => void
};

const SearchField = ({placeholder, value, onChange, onClear}: Props) => (
  <div className="SearchField">
    <input
      type="search"
      name="query"
      placeholder={placeholder}
      value={value}
      onChange={onChange} />
    {onClear && !_.isEmpty(value) &&
      <span
        className="clear-wrapper">
        <span
          className="Select-clear"
          onClick={onClear}>
          ×
        </span>
      </span>
    }
  </div>
);

SearchField.defaultProps = {
  placeHolder: 'Sök',
};

export default SearchField;



// WEBPACK FOOTER //
// ./src/components/SearchField/SearchField.js